module.exports = __webpack_public_path__ + "images/emoji/dancers.e2d1373a6d5b2f9327bd.png";